import { v4 as uuidv4 } from "uuid";

import { tReduxAction } from "../types";
import _ from "lodash";
import { tImage, tProductsBulkRequestBody } from "tmt_api/src/types/types.validator";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import { getApiError, putProductsBulk } from "src/util/apiNew";

export const uploadProductImage = ({
  id,
  productImages,
  file,
}: {
  id?: string;
  productImages?: Array<tImage>;
  file?: File;
}): tReduxAction => {
  return (dispatch) => {
    return Promise.resolve()
      .then(() => {
        if (id && file) {
          const uuid = uuidv4();
          const kFileExt = file.type.replace(/^.*\//gm, "");
          const aImageRef = firebase.storage().ref(`brands/${id}/products/product${uuid}.${kFileExt}`);
          return aImageRef.put(file);
        } else {
          throw new Error("brand id is undefined");
        }
      })
      .then((myUploadResults) => {
        return myUploadResults.ref.getDownloadURL();
      })
      .then((url) => {
        const tempImages = _.cloneDeep(productImages ?? []);
        tempImages.push({ image_url: url });
        dispatch({ type: "SET_PRODUCT", productPart: { images: tempImages } });
      })
      .catch((e: Error) => {
        dispatch({ type: "ERROR", error: e });
      });
  };
};

export const replaceProductImage = ({
  id,
  index,
  productImages,
  file,
}: {
  id?: string;
  index: number;
  productImages?: Array<tImage>;
  file?: File;
}): tReduxAction => {
  return (dispatch) => {
    return Promise.resolve()
      .then(() => {
        if (id && file) {
          const uuid = uuidv4();
          const kFileExt = file.type.replace(/^.*\//gm, "");
          const aImageRef = firebase.storage().ref(`brands/${id}/products/product${uuid}.${kFileExt}`);
          return aImageRef.put(file);
        } else {
          throw new Error("brand id is undefined");
        }
      })
      .then((myUploadResults) => {
        return myUploadResults.ref.getDownloadURL();
      })
      .then((url) => {
        const tempImages = _.cloneDeep(productImages ?? []);
        tempImages.splice(index, 1, { image_url: url });
        dispatch({ type: "SET_PRODUCT", productPart: { images: tempImages } });
      })
      .catch((e: Error) => {
        dispatch({ type: "ERROR", error: e });
      });
  };
};

export const deleteProductImage = ({
  index,
  productImages,
}: {
  index: number;
  productImages?: Array<tImage>;
}): tReduxAction => {
  return (dispatch) => {
    const tempImages = _.cloneDeep(productImages ?? []).filter((_image, imageIndex) => index !== imageIndex);
    dispatch({ type: "SET_PRODUCT", productPart: { images: tempImages } });
  };
};

export const replaceVariantImage = ({ id, index, file }: { id?: string; index: number; file?: File }): tReduxAction => {
  return (dispatch) => {
    return Promise.resolve()
      .then(() => {
        if (id && file) {
          const uuid = uuidv4();
          const kFileExt = file.type.replace(/^.*\//gm, "");
          const aImageRef = firebase.storage().ref(`brands/${id}/products/variant${uuid}.${kFileExt}`);
          return aImageRef.put(file);
        } else {
          throw new Error("brand id is undefined");
        }
      })
      .then((myUploadResults) => {
        return myUploadResults.ref.getDownloadURL();
      })
      .then((url) => {
        dispatch({
          type: "UPDATE_VARIANT_ARRAY",
          singleVariantPart: { imageUrl: url },
          index,
        });
      })
      .catch((e: Error) => {
        dispatch({ type: "ERROR", error: e });
      });
  };
};

export const bulkEdit = (payload: tProductsBulkRequestBody): tReduxAction => {
  return async (dispatch) => {
    try {
      await putProductsBulk(payload);
    } catch (e) {
      const error = getApiError(e);
      dispatch({ type: "RIBBON", message: new Error(error.message) });
    }
  };
};
